import { useState } from 'react';
import { api } from '../api';
import { HONEYPOT_FIELD } from '../honeypot';

export function ClaimForm(props: { eventId: string; onDone: () => void }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [note, setNote] = useState('');
  const [fax, setFax] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        setBusy(true);
        setErr('');
        try {
          await api.postJson('/claims', {
            event_id: props.eventId,
            claimant_name: name,
            claimant_email: email,
            claimant_phone: phone,
            verification_note: note,
            [HONEYPOT_FIELD]: fax,
          });
          props.onDone();
        } catch {
          setErr('Something went wrong sending your claim. Please try again.');
        } finally {
          setBusy(false);
        }
      }}
    >
      <label htmlFor="claim-name">Your name</label>
      <input id="claim-name" required value={name} onChange={(e) => setName(e.target.value)} />
      <label htmlFor="claim-email">Email</label>
      <input id="claim-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
      <label htmlFor="claim-phone">Phone (optional)</label>
      <input id="claim-phone" value={phone} onChange={(e) => setPhone(e.target.value)} />
      <label htmlFor="claim-note">How can we verify this is yours?</label>
      <textarea id="claim-note" required minLength={5} value={note} onChange={(e) => setNote(e.target.value)} />
      {/* honeypot — hidden from people, irresistible to bots */}
      <div aria-hidden="true" style={{ position: 'absolute', left: '-9999px', width: 1, height: 1, overflow: 'hidden' }}>
        <label htmlFor="claim-fax">Fax number</label>
        <input id="claim-fax" name={HONEYPOT_FIELD} tabIndex={-1} autoComplete="off" value={fax} onChange={(e) => setFax(e.target.value)} />
      </div>
      {err && (
        <p className="error" role="alert">
          {err}
        </p>
      )}
      <button className="primary" type="submit" disabled={busy}>
        Send claim request
      </button>
    </form>
  );
}
